var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.21 76.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.26,23.44a7.92,7.92,0,0,0-7.15,3.12,7.95,7.95,0,0,0-14.26,4.08,7.87,7.87,0,0,0,2,6,11,11,0,0,1,3,7.33v5.52a3.29,3.29,0,0,0,3.3,3.29h0a3.29,3.29,0,0,0,3.3-3.29V42.74a2.69,2.69,0,0,1,2.69-2.69h0a2.7,2.7,0,0,1,2.69,2.69v6.78a3.29,3.29,0,0,0,3.29,3.29h0a3.29,3.29,0,0,0,3.3-3.29V44a11,11,0,0,1,3-7.33,7.94,7.94,0,0,0-5.09-13.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.83,31.54a3.24,3.24,0,0,1,3.24-3.24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.11,
    cy: 38.11,
    r: 29.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.11,
    cy: 38.11,
    r: 23.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.11,
    y1: 14.49,
    x2: 38.11,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.11,
    y1: 75.21,
    x2: 38.11,
    y2: 61.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61.72,
    y1: 38.11,
    x2: 75.21,
    y2: 38.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1,
    y1: 38.11,
    x2: 14.49,
    y2: 38.11
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset9);
export default __webpack_public_path__ + "static/media/Asset 9.5fb2eeb12151c50336ee633be22040e1.svg";
export { ForwardRef as ReactComponent };